export function esc_title( string ) {
	string = string.toLowerCase().replace( /[áàâå]/g, 'a' )
		.replace( /[ø]/g, 'o' )
		.replace( /[úùû]/g, 'u' )
		.replace( /[äæ]/g, 'ae' )
		.replace( /[ö]/g, 'oe' )
		.replace( /[ü]/g, 'ue' )
		.replace( /[ß]/g, 'ss' )
		.replace( /[éèë]/g, 'e' )
		.replace( /[í]/g, 'i' );
	return string.replace( /[^0-9a-z]/gi, '' );
}

export function clamp( value, min, max ) {
	if ( value < min ) return min;
	if ( value > max ) return max;
	return value;
}

export function parseJsonToMapStrict(jsonString) {
  const maskedJsonStr = jsonString.replace(/"(\d+)":/g, '"_$1":')
  return JSON.parse(maskedJsonStr, (key, value) => {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      const orderedMap = new Map()

      for (const [k, v] of Object.entries(value)) {
        const originalKey = k.startsWith('_') ? k.slice(1) : k
        orderedMap.set(originalKey, v)
      }
      return orderedMap
    }
    return value
  })
}

export function asArray(array) {
	return [].concat(array ?? []);
}

export function arrayToQueryStringParameter(array) {
	return asArray(array).sort().join(',');
}

export function ucfirst(str) {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function isNullOrUndefined(value) {
  return value === undefined || value === null
}

export function getIfMatchForETags(...etags) {
  return etags
    .filter((v) => !isNullOrUndefined(v))
    .map((etag) => `"${etag}"`)
    .join(',')
}

/**
 * Format a number with German locale (de-AT/de-DE).
 * Simplified from the SPA version — no rounding modes, no numeral.js.
 */
const numberFmt = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function formatNumber(number, options = {}) {
  const {fractionDigits = 2, minFractionDigits = null} = options

  if (number === undefined || number === null) return '-'
  if (isNaN(number) || !isFinite(number)) return '-'

  // Fast path — default case
  if (fractionDigits === 2 && minFractionDigits === null) {
    return numberFmt.format(number)
  }

  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: minFractionDigits === true ? 2 : (minFractionDigits ?? fractionDigits),
    maximumFractionDigits: fractionDigits,
  }).format(number)
}

// Status badge styles used by ArticlesItem.vue
const tagStyles = ' inline-block px-[9px] py-[5px] text-sm font-medium rounded-md '

export const statusStyles = {
  delivered: 'text-green-700 bg-green-50 ring-green-600/20' + tagStyles,
  dispatched: 'text-blue-900 bg-blue-50 ring-gray-100/10' + tagStyles,
  received: 'text-gray-900 bg-gray-100 ring-gray-100/10' + tagStyles,
  overdue: 'text-red-700 bg-red-50 ring-red-600/10' + tagStyles,
  pending: 'text-yellow-800 bg-yellow-50 ring-yellow-600/10' + tagStyles,
}

